import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { PlanDetailComponent } from './plan-detail/plan-detail.component';
const routes: Routes = [
    // { path: 'enroll/esiid/:esiid/tdu/:tdu', component: PlanDetailComponent, },
    // { path: 'enroll/zipcode/:zipcode/tdu/:tdu', component: PlanDetailComponent, },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlanRoutingModule { 
	
}



// WEBPACK FOOTER //
// ./src/app/plan/plan-routing.module.ts